import { render, staticRenderFns } from "./PressReleases.vue?vue&type=template&id=4d55d7fa&scoped=true&"
import script from "./PressReleases.vue?vue&type=script&lang=js&"
export * from "./PressReleases.vue?vue&type=script&lang=js&"
import style0 from "./PressReleases.vue?vue&type=style&index=0&id=4d55d7fa&prod&scoped=true&lang=scss&"
import style1 from "./PressReleases.vue?vue&type=style&index=1&id=4d55d7fa&prod&lang=scss&"
import style2 from "./PressReleases.vue?vue&type=style&index=2&id=4d55d7fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d55d7fa",
  null
  
)

export default component.exports